export default __webpack_public_path__ + "static/biotech-123aa5897a787c7bb653bbbbc2415d79.png";